/**
 * Bundled by jsDelivr using Rollup v2.79.2 and Terser v5.39.0.
 * Original file: /npm/nanostores@1.0.1/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
let e = 0,
  t = [];
function n() {
  return (
    (e += 1),
    () => {
      if (((e -= 1), 0 === e)) {
        let e = t;
        t = [];
        for (let t of e) t();
      }
    }
  );
}
function l(e) {
  let t = n(),
    l = e().finally(t);
  return (l.t = !0), l;
}
function r() {
  return 0 === e
    ? Promise.resolve()
    : new Promise((e) => {
        t.push(e);
      });
}
function u() {
  e = 0;
}
let i = Symbol("clean"),
  s = (...e) => {
    throw new Error(
      "cleanStores() can be used only during development or tests"
    );
  },
  o = [],
  f = 0;
let a = 0,
  c = (e) => {
    let t = [],
      n = {
        get: () => (n.lc || n.listen(() => {})(), n.value),
        lc: 0,
        listen: (e) => (
          (n.lc = t.push(e)),
          () => {
            for (let t = f + 4; t < o.length; )
              o[t] === e ? o.splice(t, 4) : (t += 4);
            let l = t.indexOf(e);
            ~l && (t.splice(l, 1), --n.lc || n.off());
          }
        ),
        notify(e, l) {
          a++;
          let r = !o.length;
          for (let r of t) o.push(r, n.value, e, l);
          if (r) {
            for (f = 0; f < o.length; f += 4)
              o[f](o[f + 1], o[f + 2], o[f + 3]);
            o.length = 0;
          }
        },
        off() {},
        set(e) {
          let t = n.value;
          t !== e && ((n.value = e), n.notify(t));
        },
        subscribe(e) {
          let t = n.listen(e);
          return e(n.value), t;
        },
        value: e,
      };
    return n;
  };
const v = (e) => e;
let d = (e, t, n, l) => (
    (e.events = e.events || {}),
    e.events[n + 10] ||
      (e.events[n + 10] = l((t) => {
        e.events[n].reduceRight((e, t) => (t(e), e), { shared: {}, ...t });
      })),
    (e.events[n] = e.events[n] || []),
    e.events[n].push(t),
    () => {
      let l = e.events[n],
        r = l.indexOf(t);
      l.splice(r, 1),
        l.length ||
          (delete e.events[n], e.events[n + 10](), delete e.events[n + 10]);
    }
  ),
  h = (e, t) =>
    d(e, t, 0, (t) => {
      let n = e.listen;
      return (
        (e.listen = (l) => (
          e.lc || e.starting || ((e.starting = !0), t(), delete e.starting),
          n(l)
        )),
        () => {
          e.listen = n;
        }
      );
    }),
  y = (e, t) =>
    d(e, t, 1, (t) => {
      let n = e.off;
      return (
        (e.off = () => {
          t(), n();
        }),
        () => {
          e.off = n;
        }
      );
    }),
  g = (e, t) =>
    d(e, t, 2, (t) => {
      let n = e.set,
        l = e.setKey;
      return (
        e.setKey &&
          (e.setKey = (n, r) => {
            let u;
            if (
              (t({
                abort: () => {
                  u = !0;
                },
                changed: n,
                newValue: { ...e.value, [n]: r },
              }),
              !u)
            )
              return l(n, r);
          }),
        (e.set = (e) => {
          let l;
          if (
            (t({
              abort: () => {
                l = !0;
              },
              newValue: e,
            }),
            !l)
          )
            return n(e);
        }),
        () => {
          (e.set = n), (e.setKey = l);
        }
      );
    }),
  p = (e, t) =>
    d(e, t, 3, (t) => {
      let n = e.notify;
      return (
        (e.notify = (e, l) => {
          let r;
          if (
            (t({
              abort: () => {
                r = !0;
              },
              changed: l,
              oldValue: e,
            }),
            !r)
          )
            return n(e, l);
        }),
        () => {
          e.notify = n;
        }
      );
    }),
  m = 1e3,
  b = (e, t) =>
    d(
      e,
      (n) => {
        let l = t(n);
        l && e.events[6].push(l);
      },
      5,
      (t) => {
        let n = e.listen;
        e.listen = (...l) => (
          e.lc || e.active || ((e.active = !0), t()), n(...l)
        );
        let l = e.off;
        return (
          (e.events[6] = []),
          (e.off = () => {
            l(),
              setTimeout(() => {
                if (e.active && !e.lc) {
                  e.active = !1;
                  for (let t of e.events[6]) t();
                  e.events[6] = [];
                }
              }, 1e3);
          }),
          () => {
            (e.listen = n), (e.off = l);
          }
        );
      }
    ),
  A = (e, t, n) => {
    let l, r;
    Array.isArray(e) || (e = [e]);
    let u,
      i = () => {
        if (r === a) return;
        r = a;
        let n = e.map((e) => e.get());
        if (!l || n.some((e, t) => e !== l[t])) {
          l = n;
          let e = t(...n);
          e && e.then && e.t
            ? e.then((e) => {
                l === n && s.set(e);
              })
            : (s.set(e), (r = a));
        }
      },
      s = c(void 0),
      o = s.get;
    s.get = () => (i(), o());
    let f = n
      ? () => {
          clearTimeout(u), (u = setTimeout(i));
        }
      : i;
    return (
      b(s, () => {
        let t = e.map((e) => e.listen(f));
        return (
          i(),
          () => {
            for (let e of t) e();
          }
        );
      }),
      s
    );
  },
  w = (e, t) => A(e, t),
  K = (e, t) => A(e, t, !0);
function x(e, t) {
  let n = E(t),
    l = e;
  for (let e of n) {
    if (void 0 === l) break;
    l = l[e];
  }
  return l;
}
function S(e, t, n) {
  return T(null != e ? e : {}, E(t), n);
}
function T(e, t, n) {
  let l = t[0],
    r = Array.isArray(e) ? [...e] : { ...e };
  return 1 === t.length
    ? (void 0 === n
        ? Array.isArray(r)
          ? r.splice(l, 1)
          : delete r[l]
        : (r[l] = n),
      r)
    : ((function (e, t, n) {
        if (t in e) return;
        P.test(n) ? (e[t] = Array(parseInt(n, 10) + 1)) : (e[t] = {});
      })(r, l, t[1]),
      (r[l] = T(r[l], t.slice(1), n)),
      r);
}
const V = /(.*)\[(\d+)\]/;
function E(e) {
  return e.split(".").flatMap((e) => O(e));
}
function O(e) {
  if (V.test(e)) {
    let [, t, n] = e.match(V);
    return [...O(t), n];
  }
  return [e];
}
const P = /^\d+$/;
function k(e = {}) {
  let t = c(e);
  return (
    (t.setKey = (e, n) => {
      if (x(t.value, e) !== n) {
        let l = t.value;
        (t.value = S(t.value, e, n)), t.notify(l, e);
      }
    }),
    t
  );
}
function I(e, t) {
  return x(e.get(), t);
}
let M = (e, t) => {
    Array.isArray(e) || (e = [e]);
    let n,
      l = [],
      r = () => {
        n && n();
        let l = e.map((e) => e.get());
        n = t(...l);
      };
    return (
      (l = e.map((e) => e.listen(r))),
      r(),
      () => {
        l.forEach((e) => e()), n && n();
      }
    );
  },
  R = (e) => {
    e.listen(() => {});
  };
function $(e, t, n) {
  let l = new Set(t).add(void 0);
  return e.listen((e, t, r) => {
    l.has(r) && n(e, t, r);
  });
}
function j(e, t, n) {
  let l = $(e, t, n);
  return n(e.value), l;
}
let q = (e = {}) => {
  let t = c(e);
  return (
    (t.setKey = function (e, n) {
      let l = t.value;
      void 0 === n && e in t.value
        ? ((t.value = { ...t.value }), delete t.value[e], t.notify(l, e))
        : t.value[e] !== n &&
          ((t.value = { ...t.value, [e]: n }), t.notify(l, e));
    }),
    t
  );
};
function z(e) {
  let t = (e, ...n) => (
    t.cache[e] || (t.cache[e] = t.build(e, ...n)), t.cache[e]
  );
  return (
    (t.build = (n, ...l) => {
      let r = q({ id: n });
      return (
        b(r, () => {
          let u;
          return (
            e && (u = e(r, n, ...l)),
            () => {
              delete t.cache[n], u && u();
            }
          );
        }),
        r
      );
    }),
    (t.cache = {}),
    t
  );
}
export {
  r as allTasks,
  c as atom,
  K as batched,
  i as clean,
  s as cleanStores,
  u as cleanTasks,
  w as computed,
  k as deepMap,
  M as effect,
  I as getKey,
  x as getPath,
  R as keepMount,
  $ as listenKeys,
  q as map,
  z as mapCreator,
  b as onMount,
  p as onNotify,
  g as onSet,
  h as onStart,
  y as onStop,
  v as readonlyType,
  T as setByKey,
  S as setPath,
  n as startTask,
  m as STORE_UNMOUNT_DELAY,
  j as subscribeKeys,
  l as task,
};
export default null;
//# sourceMappingURL=/sm/95b1c7c22c0b46e36fb0945e11d0eb033f250e2779f7f287015469b7d17bef90.map
